module.exports = __webpack_public_path__ + "static/media/mexico.bc5c6be6.png";